import React, { useState } from 'react';

/**
 * "+ New group" for one organisation, opened inline in the sidebar.
 * `onCreate(name)` resolves to an error message, or null on success (the
 * caller then selects the new group).
 */
const NewGroupForm = ({ organisationName, onCreate }) => {
  const [open, setOpen] = useState(false);
  const [name, setName] = useState('');
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState('');

  const close = () => {
    setOpen(false);
    setName('');
    setError('');
  };

  const submit = async (event) => {
    event.preventDefault();
    const trimmed = name.trim();
    if (!trimmed || saving) return;
    setSaving(true);
    setError('');
    const failure = await onCreate(trimmed);
    setSaving(false);
    if (failure) setError(failure);
    else close();
  };

  if (!open) {
    return (
      <button type="button" className="td-scope__new" onClick={() => setOpen(true)}>
        + New group
      </button>
    );
  }

  return (
    <form className="td-scope__form" onSubmit={submit} aria-label={`New group in ${organisationName}`}>
      <label className="td-field">
        <span>Group name</span>
        <input
          value={name}
          onChange={(e) => setName(e.target.value)}
          placeholder="e.g. Tuesday LNAT session"
          autoFocus
        />
      </label>
      {error ? <div className="td-error" role="alert">{error}</div> : null}
      <div className="td-scope__formactions">
        <button type="submit" className="td-btn td-btn--confirm" disabled={saving || !name.trim()}>
          {saving ? 'Creating…' : 'Create'}
        </button>
        <button type="button" className="td-btn" onClick={close} disabled={saving}>Cancel</button>
      </div>
    </form>
  );
};

export default NewGroupForm;
